import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash'

import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import Paper from '@material-ui/core/Paper';
import {withRouter} from "react-router-dom";
import AddCircle from '@material-ui/icons/AddCircleOutline';
import moment from 'moment'
import AddCustomerUser from './AddCustomerUser'
import { inject, observer } from 'mobx-react';
import { observable, reaction } from 'mobx';
import {pending, done} from '../stores/State'
import People from '@material-ui/icons/People';

@inject('store')
@observer
class CustomerUsers extends Component {
  @observable addCustomerOpen = false;

  componentDidMount(){
    //Add reaction when result changes
    this.reactionHandler = reaction(()=>this.props.store.customerStore.customer.createUserState, (state)=>{
      if(state === done){
        this.addCustomerOpen = false;
      }
    });
  }
  componentWillUnmount(){
    this.reactionHandler();
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props, nextProps)) this.fetchData(nextProps.customerId);
  }

  deleteUser(user){
    const store = this.props.store.customerStore; 
    store.deleteCustomerUser(this.props.customerId, user.id)
  }
  render() {
    const { classes } = this.props;
    const store  = this.props.store.customerStore;
    
    return (
      <div>
        <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><People/>Users</Typography>
          { store.customerState === pending && <CircularProgress /> }
          { store.customer && 
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Created at</TableCell>
                  {/*<TableCell>Action</TableCell>*/}
                </TableRow>
              </TableHead>
              <TableBody>
                {store.customer.users.map(user => {
                  return (
                    <TableRow key={user.id}>
                      <TableCell>{user.username}</TableCell>
                      <TableCell>{moment(user.created_at).format('lll')}</TableCell>
                      {/*
                      <TableCell>
                        <Button size="small" className={classes.button} onClick={()=>this.props.history.push('/customers/new')}>Revoke</Button>
                      </TableCell>
                      */}
                    </TableRow>
                  );
                })}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan="3">
                    <Button size="small" className={classes.button} variant="contained" color='primary' onClick={()=>this.addCustomerOpen = true}>New user<AddCircle className={classes.icon}/></Button>
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table> }
          </Paper>
          <AddCustomerUser customerId={this.props.customerId} handleClose={()=>this.addCustomerOpen = false} open={this.addCustomerOpen}/>
        </div>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  },
  button:{
    margin: 5
  },
  icon:{
    marginLeft: 5
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

CustomerUsers.propTypes = {
  customerId: PropTypes.number
}

export default withRouter(withStyles(styles)(CustomerUsers));



// WEBPACK FOOTER //
// ./src/components/CustomerUsers.js